(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-video')) {
  customElements.define('maison-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const button = this.querySelector('button');
      const ensureVideo = () => {
        let video = this.querySelector('video');
        if (!video) {
          this.prepend(this.querySelector('template').content.cloneNode(true));
          video = this.querySelector('video');
        }
        return video;
      };
      const play = async () => {
        const video = ensureVideo();
        if (!video || !video.paused) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        if (this.hasAttribute('data-continuous')) {
          video.loop = true;
          video.autoplay = true;
          video.controls = false;
          video.removeAttribute('controls');
        }
        try { await video.play(); this.update(true); } catch { this.update(false); }
      };
      const pause = () => { this.querySelector('video')?.pause(); this.update(false); };
      button?.addEventListener('click', () => {
        this.userControlled = true;
        const video = this.querySelector('video');
        if (!video || video.paused) play(); else pause();
      }, { signal });
      this.addEventListener('pause', () => this.update(false), { signal, capture: true });
      this.addEventListener('play', () => this.update(true), { signal, capture: true });
      reduced.addEventListener('change', () => { if (reduced.matches) pause(); }, { signal });
      const resume = () => {
        if (this.inView && this.hasAttribute('data-autoplay') && !reduced.matches && !this.userControlled && !document.hidden) play();
      };
      if (this.hasAttribute('data-continuous')) {
        this.addEventListener('loadeddata', resume, { signal, capture: true });
        this.addEventListener('canplay', resume, { signal, capture: true });
        this.addEventListener('ended', resume, { signal, capture: true });
        window.addEventListener('pageshow', resume, { signal });
        document.addEventListener('touchend', resume, { signal, passive: true });
        document.addEventListener('click', resume, { signal, passive: true });
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); else resume(); }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (!this.inView || reduced.matches) pause();
        else resume();
      }, { threshold: 0.05 });
      this.observer.observe(this);
    }
    update(playing) {
      const button = this.querySelector('button');
      if (!button) return;
      button.textContent = playing ? this.dataset.pause : this.dataset.play;
      button.setAttribute('aria-pressed', String(playing));
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
